export default "__VITE_ASSET__80e99bc1__"